import styled from "styled-components";

export const ContainerQuestionLike = styled.div`
  display: flex;
  justify-content: center;
`;
